import {useEffect} from 'react';
import {WidgetProps} from '@wix/yoshi-flow-editor';
import {
  PreloadMessageSource,
  PreloadMessageType,
  PreloadWarmUpStatus,
  type LoadCartMessage,
} from '../../../domain/preload/messages';
import {CheckoutControllerProps} from '../../../types/checkoutApp.types';

const notifyWarmUpStatus = (warmUpStatus: PreloadWarmUpStatus): void => {
  const type =
    warmUpStatus === PreloadWarmUpStatus.Failed ? PreloadMessageType.WarmUpLoadFailed : PreloadMessageType.Ready;
  window.parent?.postMessage({source: PreloadMessageSource.Viewer, type}, '*');
};

const notifyCartLoadFailed = (): void => {
  window.parent?.postMessage({source: PreloadMessageSource.Viewer, type: PreloadMessageType.CartLoadFailed}, '*');
};

export const usePreloadListener = (controllerProps: WidgetProps<CheckoutControllerProps>): void => {
  const {isPreload, warmUpStatus, cartLoadFailed, loadCartById} = controllerProps?.navigationStore ?? {};

  useEffect(() => {
    if (!isPreload || !loadCartById || !warmUpStatus) {
      return;
    }

    const handler = (event: MessageEvent): void => {
      if (event.source !== window.parent) {
        return;
      }
      const data = event.data as Partial<LoadCartMessage>;
      if (data?.source !== PreloadMessageSource.Host || data.type !== PreloadMessageType.LoadCart) {
        return;
      }
      const cartId = data.payload?.cartId;
      if (cartId) {
        void loadCartById(cartId);
      }
    };

    window.addEventListener('message', handler);
    notifyWarmUpStatus(warmUpStatus);

    return () => window.removeEventListener('message', handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPreload, warmUpStatus, !loadCartById]);

  useEffect(() => {
    if (!isPreload || !cartLoadFailed) {
      return;
    }

    notifyCartLoadFailed();
  }, [isPreload, cartLoadFailed]);
};
